import { render } from "./CustomLink.vue?vue&type=template&id=471f43f8&scoped=true"
import script from "./CustomLink.vue?vue&type=script&lang=js"
export * from "./CustomLink.vue?vue&type=script&lang=js"

import "./CustomLink.vue?vue&type=style&index=0&id=471f43f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471f43f8"]])

export default __exports__